const boostTypesMap = {
    ZG: 'Z',
    FACEBOOK: 'FB',
    INSTAGRAM: 'IG',
};

const BoostAdReportRow = ({
    feedListingId = '',
    feedId = '',
    cpmBoostTypes = [],
    active = false,
    insertionOrderId = null,
    totalCost = 0,
    impressions = 0,
    clicks = 0,
    cpc = 0,
    ctr = 0,
} = {}) => ({
    feedId: String(feedId),
    feedListingId: String(feedListingId),
    boostTypes: cpmBoostTypes.map(type => boostTypesMap[type]),
    active: Boolean(active),
    insertionOrderId: Number(insertionOrderId),
    totalCost: Number(totalCost),
    impressions: Number(impressions),
    clicks: Number(clicks),
    cpc: Number(cpc),
    ctr: String(`${(Number(ctr) * 100).toFixed(2)}%`),
});

export default BoostAdReportRow;
